import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutStopList extends Layout {
    sourceStop: DataSource;
    tableStop: Table;
}
